module.exports = __webpack_public_path__ + "img/new_5.96efb39e.png";